import { environment } from '../../environment';

const OIDC_LOGIN_CHALLENGE_PARAM = 'login_challenge';

export const isOidcLoginRequest = (searchParams: URLSearchParams) =>
  searchParams.has(OIDC_LOGIN_CHALLENGE_PARAM);

export const getOidcLoginChallenge = (searchParams: URLSearchParams) =>
  searchParams.get(OIDC_LOGIN_CHALLENGE_PARAM);

type OIDCLoginResponse = {
  redirect_to: string;
};

const validateOidcResponse = (body: unknown): OIDCLoginResponse => {
  if (!body || typeof body !== 'object') {
    throw new Error('OIDC Response not an object');
  }

  if (!('redirect_to' in body)) {
    throw new Error('OIDC Response does not contain redirect_to');
  }

  if (typeof body.redirect_to !== 'string') {
    throw new Error('OIDC.oidc_token must be of type string');
  }

  return { redirect_to: body.redirect_to };
};

export const oidcLogin = async ({
  username,
  password,
  login_challenge,
}: {
  username: string;
  password: string;
  login_challenge: string;
}): Promise<OIDCLoginResponse> => {
  const response = await fetch(
    `${environment.PUBLIC_GO_API_ROOT}/oauth/login`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password, login_challenge }),
    }
  );

  if (!response.ok) {
    throw new Error('OIDC login failed');
  }

  const text = await response.text();
  try {
    return validateOidcResponse(JSON.parse(text));
  } catch (err) {
    console.error(err);
  }

  throw new Error('OIDC login failed');
};
